/**
 * R28-P5 voice-consent client. Wraps the dedicated endpoints:
 *
 *   GET    /api/v1/privacy/voice-consent — current record (+ currentVersion)
 *   POST   /api/v1/privacy/voice-consent — grant (explicit opt-in)
 *   DELETE /api/v1/privacy/voice-consent — withdraw (Art. 7(3))
 *
 * These are separate from the settings store on purpose: the backend server-stamps
 * the version + timestamp and writes an audit trail, so the FE must NOT write the
 * `voice_consent` key directly. The session-start gate reads the same state.
 *
 * The Go handler returns lowerCamelCase JSON, so the shape lines up with the
 * voiceconsent.Record struct.
 */
import { apiFetch } from '@/lib/http';

export interface VoiceConsentRecord {
  granted: boolean;
  version?: string;
  grantedAt?: string;
  withdrawnAt?: string;
  /** The server's current disclosure version — compare to `version` for re-prompts. */
  currentVersion: string;
}

export async function getVoiceConsent(signal?: AbortSignal): Promise<VoiceConsentRecord> {
  const init: RequestInit = { method: 'GET' };
  if (signal) init.signal = signal;
  return apiFetch<VoiceConsentRecord>('/api/v1/privacy/voice-consent', init);
}

export async function grantVoiceConsent(): Promise<VoiceConsentRecord> {
  return apiFetch<VoiceConsentRecord>('/api/v1/privacy/voice-consent', { method: 'POST' });
}

export async function withdrawVoiceConsent(): Promise<VoiceConsentRecord> {
  return apiFetch<VoiceConsentRecord>('/api/v1/privacy/voice-consent', { method: 'DELETE' });
}
